import HttpClienteSeguroCore from '../../Servicios/HttpClienteSeguroCore';
import httpClientePublicoCore from '../../Servicios/httpClientePublicoCore';
import HttpClientePublicoParams from "../../Servicios/HttpClientePublicoParametros";
import HttpClienteSeguroParams from "../../Servicios/HttpClienteSeguroParametros";

export const obtenerCompania = (ComCompanyId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.get("/Compania/" + ComCompanyId).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

export const obtenerConfiguracionAppCompania = (ComCompanyId, PortalCode = 'ADMIN') => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.get("/Compania/Config/" + ComCompanyId + '/' + PortalCode).then(response => {
            resolve(response);

        })
            .catch(error => {
                resolve(error.response);
            });
    });
};


export const obtenerConfiguracionHoraFecha = (CompanyId) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.get("/Compania/ConfigHoraFecha/" + CompanyId).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

/**
 * obtener imagen.
 * @param {{
 * companyId:string,
 * peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string }}} objectRequest
 * @returns {Promise<{data:{documentName:string, extension:string, contentBase64:string, referenceObjectId:string, objectId:string}, status:number }>}
 */
export const obtenerImagenReducida = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClienteSeguroCore.post("/Compania/ObtenerImagenReducida", objectRequest).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

export const ObtenerLoginMessage = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClientePublicoParams.post('/DisennoApp/ObtenerLoginMessage', objectRequest).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};

/**
 * Se encarga obtener los datos de configuración de diseño del app por compañía. 
 * @param {{
 *          companyId:string,
 *          peticionUsuario:{ companyId:string, userId:string, optionId:string, action:string }}} objectRequest
 * @returns {Promise}
 */
export const ObtenerConfiguracion = (objectRequest) => {
    return new Promise((resolve, reject) => {
        HttpClientePublicoParams.post('/DisennoApp/Obtener', objectRequest).then(response => {
            resolve(response);
        })
            .catch(error => {
                resolve(error.response);
            });
    });
};